"use strict";var $isNaN=require("../helpers/isNaN");module.exports=function(x,y){return x===y?0!==x||1/x==1/y:$isNaN(x)&&$isNaN(y)};